import React, { useState, useEffect } from 'react'
import { GradientText } from '../PasserCommande/PasserCommande.styles'
import { getChauffeursByTransporter } from '../../api/chauffeurs'
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component'
import { useHistory } from 'react-router'
import LayoutTransporter from '../../Components/LayoutTransporter/LayoutTransporter'
import toast from 'react-hot-toast'
import moment from 'moment'
import DetailsChauffeurModal from '../../Components/DetailsChauffeur/DetailsChauffeurModal';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
function ListChauffeurs() {
	const history = useHistory()
	const transporter = useSelector((state) => state.auth.user)
	const token = useSelector((state) => state.auth.token);
	const [data, setData] = useState([])
	const [chargementEnCours, setChargementEnCours] = useState(false)
	const [totalRows, setTotalRows] = useState(0)
	const [perPage, setPerPage] = useState(10)
	const [currentPage, setCurrentPage] = useState(1)
	const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)
	const [selectedChauffeur, setSelectedChauffeur] = useState(null)
    const {t} = useTranslation();
	const fetchChauffeur = async (page, perPage) => {
		setChargementEnCours(true)
		try {
			const res = await getChauffeursByTransporter(
				transporter._id,
				page,
				perPage,
				token,
				null
			)
			setData(res.docs)
			setTotalRows(res.totalDocs)
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			setChargementEnCours(false)

		}

	}



	const handlePageChange = (page) => {
		setCurrentPage(page)
		fetchChauffeur(page, perPage)
	}
	const handlePerRowsChange = async (newPerPage, page) => {
		fetchChauffeur(page, newPerPage)
		setPerPage(newPerPage)
	}

	useEffect(() => {
		fetchChauffeur(currentPage, perPage)
	}, [])


	const columns = [
		{
			name: "ID",
			selector: (row) => row.__id,
		},
		{
			name: t("driver_name"),
			selector: (row) => `${row.first_name} ${row.last_name}`,
			sortable: false,
		},
		{
			name: 'Email',
			selector: (row) => `${row.email}`,
			sortable: false,
			width: '250px'
		},
		{
			name: t("status"),
			selector: (row) => {
				if (row.status === 'actif') return t("active");
				if (row.status === 'suspendu') return t("suspended");
				if (row.status === 'en-attente') return t("pending");
				return t("unknown");
			},
			sortable: false,
		},
		{
			name: t("suspension_date"),
			selector: (row) => (row.status === "suspendu" ? moment(row?.date_suspension).format('DD/MM/YYYY') : '__'),
			sortable: false,
		},
		{
			name: 'Actions',
			button: true,
			cell: (row) => (
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
							}}
						>
							<div
								onClick={() => {
									setSelectedChauffeur(row?._id)
									setModalIsOpenDetail(true)
								}}
								style={{
									cursor: 'pointer',
								}}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
								>
									<path
										fill="#51C7F2"
										d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
									/>
									<path
										fill="#51C7F2"
										d="M11 7h2v7h-2zm0 8h2v2h-2z"
									/>
								</svg>

							</div>
						</div>




					</div>

					<div
						onClick={() => {
							history.push(
								`/chauffeurs/${row._id}/edit`
							)
						}}
						style={{
							cursor: 'pointer',
						}}
					>
						<div
							style={{
								height: 24,
								width: 24,
								color: '#51C7F2',
							}}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								viewBox='0 0 20 20'
								fill='currentColor'
							>
								<path d='M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z' />
								<path
									fillRule='evenodd'
									d='M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z'
									clipRule='evenodd'
								/>
							</svg>
						</div>
					</div>





				</div>
			),
		},
	];
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<LayoutTransporter>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					fontFamily: 'Montserrat',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection:  'row',
						alignItems: 'center',
						justifyContent: 'center',
						marginBottom: '1rem',
						gap:  '1rem'
					}}
				>

					<GradientText style={{
						fontSize: isSmallScreen ? '2rem' : '2.5rem',
						marginTop: 0
					}}>
						{t("my_drivers").toUpperCase()}
					</GradientText>

					<div
						onClick={() => history.push('/chauffeurs/new')}
						style={{
							background: '#51C7F2',
							padding:isSmallScreen? '0.4rem': '1rem 2rem',
							borderRadius: isSmallScreen? '100%' : 5,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
						}}
					>
						{ isSmallScreen? 
						<AddIcon style={{color: 'white'}}/>:
						<span
							style={{
								color: 'white',
								fontSize: '1rem',
								fontWeight: 'bold',
							}}
						>
							{t("add")}
						</span>}
					</div>

				</div>
				{isSmallScreen ?
				   data.length === 0 ? t("no_drivers") :
					data.map((chauffeur) => {
						return <div style={{
							width: '100%',
							background: '#E4EAF0',
							display: 'flex',
							flexDirection: 'column',
							padding: '1rem',
							borderRadius: 10,
							alignItems: 'flex-start',
							marginBottom: 10,
						}}>
							<div style={{
								fontWeight: 'bolder',
								color: '#1C63C5',
								fontSize: '1.2rem',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								width: '100%'
							}}>
								<span>{chauffeur.first_name}{' '}{chauffeur.last_name}</span>
								<div style={{ display: 'flex', gap: '5px' }}>
									<div
										onClick={() => {
											setSelectedChauffeur(chauffeur?._id)
											setModalIsOpenDetail(true)
										}}
										style={{
											cursor: 'pointer',
										}}
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="24"
											height="24"
											viewBox="0 0 24 24"
										>
											<path
												fill="#51C7F2"
												d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
											/>
											<path
												fill="#51C7F2"
												d="M11 7h2v7h-2zm0 8h2v2h-2z"
											/>
										</svg>

									</div>
									<div
										onClick={() => {
											history.push(
												`/chauffeurs/${chauffeur._id}/edit`
											)
										}}
										style={{
											cursor: 'pointer',
										}}
									>
										<div
											style={{
												height: 24,
												width: 24,
												color: '#51C7F2',
											}}
										>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												viewBox='0 0 20 20'
												fill='currentColor'
											>
												<path d='M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z' />
												<path
													fillRule='evenodd'
													d='M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z'
													clipRule='evenodd'
												/>
											</svg>
										</div>
									</div>
								</div>
							</div>
							<span style={{
								color: '#838EAB',
								fontSize: '0.9rem',
								fontWeight: 'bolder',
								marginBottom: '1.5rem',
							}}>{chauffeur.__id}</span>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}>
								Email:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}>{chauffeur.email}</span>
							</span>
							<span style={{
								color: '#838EAB',
								fontSize: '0.9rem',
								marginBottom: '0.8rem',
							}}>
								{t("status")}:{' '}
								<span style={{
									fontSize: '0.9rem',
									fontWeight: 'bolder',
									color: chauffeur.status === 'suspendu' ? "#B91C1C" : chauffeur.status === 'en-attente' ? 'orange' : "#047857"
								}}>{chauffeur.status === 'suspendu' ? t("suspended") : chauffeur.status === 'en-attente' ? t("pending") : chauffeur.status === 'actif' ? t("active") : t("unknown")}</span>
							</span>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}
							>{t("suspension_date")}:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}>{chauffeur.status === "suspendu" ? moment(chauffeur?.date_suspension).format('DD/MM/YYYY') : '__'}</span>
							</span>
						</div>
					})
					:
					<div
						style={{
							width: '100%',
							padding: '0 1rem',
							marginTop: '2rem'
						}}
					>
						<DataTable
							columns={columns}
							data={data}
							progressPending={chargementEnCours}
							pagination
							paginationServer
							paginationTotalRows={totalRows}
							onChangeRowsPerPage={handlePerRowsChange}
							onChangePage={handlePageChange}
							noDataComponent={t("no_drivers")}
							progressComponent={
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										backgroundColor: 'white',
										marginTop: "10rem"
									}}
								>
									<div className='customLoader'></div>
								</div>
							}
							paginationComponentOptions={{
								rowsPerPageText: t("rows_per_page"),
								rangeSeparatorText: t("of"),
							}}
						/>
					</div>}
			</div>
			<DetailsChauffeurModal
				isOpen={modalIsOpenDetail}
				onClose={() => setModalIsOpenDetail(false)}
				chauffeurId={selectedChauffeur}
			/>
		</LayoutTransporter>
	)
}

export default ListChauffeurs